import {Component} from "@angular/core";
import {provideEntityModel, provideSearchModel} from "@fedeltapointofsale/data-client";
import {TableDefinitionSearchModel} from "../table-definition-search-model.service";
import {TableDefinitionEntityModel} from "../table-definition-entity-model.service";
import {AbstractSearchPage} from "../../../framework/entity/search/search-page/abstract-search-page";

@Component({
    selector: "wbo-table-definition-search-page",
    templateUrl: "./table-definition-search-page.component.html",
    providers: [provideSearchModel(TableDefinitionSearchModel), provideEntityModel(TableDefinitionEntityModel)]
})
export class TableDefinitionSearchPageComponent extends AbstractSearchPage {
    constructor() {
        super();
    }
}
